export default "__VITE_ASSET__nN9jy7vb__"